import { AbstractScatterVisualization } from '../visualization.abstract.scatter.component';
export class LinearSVRGraph extends AbstractScatterVisualization {
}
